export default [
  {
    type: "monthly",
    year: 2021,
    month: 1,
    btc: 50.4,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1234/marathon-digital-holdings-announces-bitcoin-production-and"
  },
  {
    type: "monthly",
    year: 2021,
    month: 2,
    btc: 43.4,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1234/marathon-digital-holdings-announces-bitcoin-production-and"
  },
  {
    type: "monthly",
    year: 2021,
    month: 3,
    btc: 102.3,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1234/marathon-digital-holdings-announces-bitcoin-production-and"
  },
  {
    type: "monthly",
    year: 2021,
    month: 4,
    btc: 162.1,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1238/marathon-digital-holdings-announces-bitcoin-production-and"
  },
  {
    type: "monthly",
    year: 2021,
    month: 5,
    btc: 226.6,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1245/marathon-digital-holdings-announces-bitcoin-production-and"
  },
  {
    type: "monthly",
    year: 2021,
    month: 6,
    btc: 265.6,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1247/marathon-digital-holdings-announces-bitcoin-production-and"
  },
  {
    type: "monthly",
    year: 2021,
    month: 7,
    btc: 442.2,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1252/marathon-digital-holdings-announces-bitcoin-production-and"
  },
  {
    type: "monthly",
    year: 2021,
    month: 8,
    btc: 469.6,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1256/marathon-digital-holdings-announces-bitcoin-production-and"
  },
  {
    type: "monthly",
    year: 2021,
    month: 9,
    btc: 340.6,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1259/marathon-digital-holdings-announces-bitcoin-production-and"
  },
  {
    type: "monthly",
    year: 2021,
    month: 10,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 11,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 12,
    btc: 0,
    source: ""
  },
  /* Quarterly */
  {
    type: "quarterly",
    year: 2020,
    quarter: 1,
    btc: 0,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1198/marathon-patent-group-announces-2020-fiscal-first-quarter"
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 2,
    btc: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 3,
    btc: 0,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1214/marathon-patent-group-announces-2020-fiscal-third-quarter"
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 4,
    btc: 157,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1230/marathon-reports-fourth-quarter-and-fiscal-year-2020-results"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 1,
    btc: 192,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1240/marathon-reports-first-quarter-2021-results"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 2,
    btc: 654,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1254/marathon-digital-holdings-reports-second-quarter-2021"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 3,
    btc: 1252.4,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1259/marathon-digital-holdings-announces-bitcoin-production-and"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 4,
    btc: 0,
    source: ""
  },
]
